// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"292":"2011e3a0","502":"6495e1e6","629":"156da228"}[chunkId] + ".chunk.js";
};